import { useEffect, useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import { Grid, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TableGeneric from "../../components/Generics/TableGeneric";
import { GridColDef } from "@mui/x-data-grid";
import ButtonGeneric from "../../components/Generics/ButtonGeneric";
import { useSnack } from "../../redux/snack/snackHooks";
import { Feriado } from "../../model/entities/Feriado";
import feriadoApi from "../../api/feriadoApi";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { formatarData } from "../../helper";
import DialogConfirmGeneric from "../../components/Generics/DialogConfirmGeneric";

type Props = {};

const FeriadosPage: React.FC<Props> = (props) => {
  const [feriados, setFeriados] = useState<Feriado[]>([]);
  const [totalLinhas, setTotalLinhas] = useState(0);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [pagina, setPagina] = useState(0);
  const [linhasPorPagina, setLinhasPorPagina] = useState(5);
  const mostrarSnack = useSnack();

  const [openConfirmaExclusao, setOpenConfirmaExclusao] = useState(false);
  const [feriadoSelecionadoExcluir, setFeriadoSelecionadoExcluir] =
    useState<Feriado | null>(null);

  useEffect(() => {
    buscarFeriados();
  }, []);

  const buscarFeriados = async () => {
    try {
      setLoading(true);
      const count = await feriadoApi.count();
      setTotalLinhas(count);

      const res = await feriadoApi.getMany(pagina, linhasPorPagina);
      setFeriados(res);
      setLoading(false);
    } catch (erro: any) {
      mostrarSnack(
        "Ops); Aconteceu um problema ao buscar os feriados !!",
        "error"
      );
      console.log("erro ao buscar feriados", erro);
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarFeriados();
  }, [pagina, linhasPorPagina]);

  const navegarTelaFeriado = (feriado: Feriado) => {
    navigate(`/configuracoes/feriado/cadastro`, { state: feriado });
  };

  const columns: GridColDef<Feriado>[] = [
    {
      field: "titulo",
      headerName: "Titulo",
      width: 230,
      editable: false,
    },
    {
      field: "data",
      headerName: "Data",
      width: 230,
      editable: false,
      renderCell: (params) => {
        console.log("params.row.data", params.row.data);
        return formatarData(params.row.agendamento.startDate.toString());
      },
    },
    {
      field: "descricao",
      headerName: "Descrição",
      width: 650,
      editable: false,
    },
    {
      field: "acoes",
      headerName: "Ações",
      width: 230,
      editable: false,
      renderCell: (params) => {
        const feriado = params.row;
        return (
          <>
            <IconButton onClick={(e) => e.stopPropagation()}>
              <DeleteIcon
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setFeriadoSelecionadoExcluir(feriado);
                }}
              />
            </IconButton>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (feriadoSelecionadoExcluir) {
      setOpenConfirmaExclusao(true);
    }
  }, [feriadoSelecionadoExcluir]);

  const excluir = async () => {
    try {
      if (!feriadoSelecionadoExcluir) {
        mostrarSnack("Nenhum feriado selecionado para exclusão", "error");
        return;
      }
      await feriadoApi.delete(feriadoSelecionadoExcluir.id);
      buscarFeriados();
      mostrarSnack("Feriado excluido!", "success");
    } catch (erro: any) {
      console.log("Erro ao excluir feriado ", erro);
      mostrarSnack("Erro ao excluir feriado", "error");
    }
  };

  return (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={12} style={{ textAlign: "right" }}>
        <ButtonGeneric
          startIcon={<AddCircleIcon />}
          label="Cadastrar Novo Feriado"
          onClick={() => navigate(`/configuracoes/feriado/cadastro`)}
        />
      </Grid>

      <Grid item xs={12}>
        <TableGeneric
          paginaAtual={pagina}
          pageSize={linhasPorPagina}
          colunas={columns}
          linhas={feriados}
          loading={loading}
          totalLinhas={totalLinhas}
          selecionaLinha={false}
          onRowClick={(params) => {
            navegarTelaFeriado(params.row);
          }}
          formasDeListar={[5, 10]}
          setPaginacao={(model) => {
            setPagina(model.page);
            setLinhasPorPagina(model.pageSize);
          }}
        />
      </Grid>

      {openConfirmaExclusao && (
        <DialogConfirmGeneric
          open={openConfirmaExclusao}
          cabecalho={"Confirmar "}
          texto={"Confirmar exclusão de feriado ?"}
          onResposta={(res) => {
            if (res) {
              excluir();
              setOpenConfirmaExclusao(false);
            } else {
              setOpenConfirmaExclusao(false);
              setFeriadoSelecionadoExcluir(null);
            }
          }}
        />
      )}
    </Grid>
  );
};

export default FeriadosPage;
